import React, {Component} from 'react';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import Meta from '../model/Meta';

class Help extends Component {

    constructor(props) {
        super(props);
        this.togglePlusMinus = this.togglePlusMinus.bind(this);
    }

    componentDidMount() {
        $('html, body').animate({scrollTop: 0}, 300);
    }

    togglePlusMinus(el) {
        $("i.fa-plus."+el).toggleClass("fa-minus");
    }

    render() {
        let helpQuestions = [
            {
                question: "Are the documents free?",
                answer: "Earnest money agreement and option contract are free. All other documents are available at an affordable price."
            },
            {
                question: "How much do the documents cost?",
                answer: "The regular price of our contracts ranges from P1750 - P2500. Since we are still in the beta stage, you can get our documents at 50% off, available for a limited time only."
            },
            {
                question: "What are the payment methods available?",
                answer: "You may settle payment thru PayPal (via credit card or PayPal account). If you don't have a credit card, we recommend using PayMaya. To know more about PayMaya and how it works, visit their website at paymaya.com."
            },
            {
                question: "How will I receive the document?",
                answer: "All documents are sent to the valid email address you provided. A download link is also provided upon checkout."
            },
            {
                question: "Can I still change or edit information after the document has been emailed?",
                answer: "Yes, you may still change or edit misspelled information on your document. Just email us at support@contracts.ph and we will correct your contract free of charge within 7 days up to 3 revisions. We will send revision within 1-2 business days."
            },
            {
                question: "I haven't received the document in my email yet, what should I do?",
                answer: "Please send an email to support@contracts.ph for assistance."
            }
        ];

        const meta = {
            title: "Help - Contracts.ph",
            description: "Help and Frequently asked question"
        }

        return(
            <div className="page page-inner pb-5">
                <Meta {...meta}/>
                <div className="container-fluid">
                    <div className="container p-0">
                        <h1 className="page-title">Help Center</h1>
                        <div className="page-content">
                            <ul className="custom-accordion list-group">
                                
                                {
                                    helpQuestions.map((obj, i)=>{
                                        return( 
                                            <li key={i} className="list-group-item">
                                                <div className="row">
                                                    <div className="col-10">
                                                        <a href={"#"+i} data-toggle="collapse" onClick={()=>this.togglePlusMinus(i)}>{obj.question}</a>
                                                        <div className="collapse" id={i}>
                                                            <p>{obj.answer}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-2 text-right">
                                                        <a href={"#"+i} data-toggle="collapse" onClick={()=>this.togglePlusMinus(i)}>
                                                            <i className={"fa fa-plus mr-2 "+i} aria-hidden="true"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })
                                }

                            </ul>
                        </div>
                    </div>
                </div>
                <div className="text-center my-3">
                    <Link
                        to="/contact"
                        className="btn btn-lightblue" >
                        Need more help? Click here to send us an email
                    </Link>
                </div>
            </div>
        );
    }
}

export default Help;


// WEBPACK FOOTER //
// ./src/pages/Help.js